import { render } from "./privacy-policy-scr.vue?vue&type=template&id=60648b4c&scoped=true"
import script from "./privacy-policy-scr.vue?vue&type=script&lang=js"
export * from "./privacy-policy-scr.vue?vue&type=script&lang=js"

import "./privacy-policy-scr.vue?vue&type=style&index=0&id=60648b4c&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60648b4c"]])

export default __exports__